module.exports = "//cdn.mxpnl.com/static/asset-cache/929a35949a7427020986d5337630f5c4/iron/common/assets/images/customer-logos/samsung-logo.png";